<template>
    <el-drawer
        size="520px"
        title="编辑加班规则"
        class="custom_attendance_overtimr_drawer"
        :visible.sync="overtimeTplDialogVisible"
        :close-on-press-escape="false"
        :wrapperClosable="false"
        :append-to-body="true"
        :before-close="handleDialogClose"
    >
        <div class="custom_overtime_drawer_wrap">
            <div class="drawer_form_content" v-loading="loading">
                <el-form
                    :model="overtimeForm"
                    :rules="overtimeFormRules"
                    label-position="top"
                    ref="overtimeForm"
                    size="small"
                    v-if="overtimeDetails && overtimeDetails.id"
                >
                    <el-form-item label="加班规则名称" prop="name">
                        <el-input
                            maxlength="20"
                            placeholder="请输入加班规则名称"
                            show-word-limit
                            v-model="overtimeForm.name"
                        ></el-input>
                    </el-form-item>
                    <el-tabs v-model="activeName" @tab-click="handleClickTab">
                        <el-tab-pane label="工作日" name="1">
                            <el-form-item label="" prop="json_rule.work_day.is_open">
                                <div class="association">
                                    <el-switch
                                        v-model="overtimeForm.json_rule.work_day.is_open"
                                        :active-value="1"
                                        :inactive-value="0"
                                    >
                                    </el-switch>
                                    允许加班
                                </div>
                            </el-form-item>

                            <template v-if="overtimeForm.json_rule.work_day.is_open == 1">
                                <el-form-item label="加班时长单位" prop="json_rule.work_day.time_unit">
                                    <el-radio-group v-model="overtimeForm.json_rule.work_day.time_unit">
                                        <el-radio label="day" :disabled="true">天</el-radio>
                                        <el-radio label="ampm" :disabled="true">半天</el-radio>
                                        <el-radio label="hour">小时</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    label="日时长结算"
                                    prop="json_rule.work_day.hour_to_day"
                                    v-if="overtimeForm.json_rule.work_day.time_unit == 'hour'"
                                >
                                    加班满
                                    <el-input-number
                                        :controls="false"
                                        :min="0"
                                        class="inputClass"
                                        placeholder="请输入"
                                        v-model="overtimeForm.json_rule.work_day.hour_to_day"
                                    >
                                    </el-input-number>
                                    小时，计为1 天
                                </el-form-item>
                                <el-form-item label="计算方式" prop="json_rule.work_day.calculation_method">
                                    <el-radio-group
                                        class="blockRadio"
                                        v-model="overtimeForm.json_rule.work_day.calculation_method"
                                    >
                                        <el-radio label="approval_time">按审批时长计算</el-radio><br />
                                        <!-- <el-radio :label="2">在审批时长内，按打卡时长计算</el-radio><br />
                                        <el-radio :label="3">无需审批，按打卡时长计算</el-radio><br /> -->
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="补偿方式" prop="json_rule.work_day.compensation_method">
                                    <el-radio-group
                                        @change="handleChange(overtimeForm.json_rule.work_day.compensation_method, 1)"
                                        class="blockRadio"
                                        v-model="overtimeForm.json_rule.work_day.compensation_method"
                                    >
                                        <div class="return_type_radio">
                                            <el-radio label="pay">计为加班费，</el-radio>
                                            <div>
                                                <span>加班费以1:</span>
                                                <el-input-number
                                                    :controls="false"
                                                    :min="0"
                                                    class="inputClass"
                                                    placeholder="请输入"
                                                    v-model="overtimeForm.json_rule.work_day.compensation_ratio"
                                                >
                                                </el-input-number>
                                                <span>结算</span>
                                            </div>
                                        </div>
                                        <div class="return_type_radio">
                                            <el-radio label="comp_leave">计为调休，</el-radio>
                                            <div>
                                                <span>加班时长以1:</span>
                                                <el-input-number
                                                    :controls="false"
                                                    :min="0"
                                                    class="inputClass inputClass_80"
                                                    placeholder="请输入"
                                                    v-model="overtimeForm.json_rule.work_day.compensation_ratio"
                                                >
                                                </el-input-number>
                                                <span>结算为调休假</span>
                                            </div>
                                        </div>
                                        <!--                  <el-radio :label="3">员工自主选择</el-radio><br>-->
                                    </el-radio-group>
                                </el-form-item>
                            </template>
                        </el-tab-pane>

                        <el-tab-pane label="休息日" name="2">
                            <el-form-item label="" prop="json_rule.off_day.is_open">
                                <div class="association">
                                    允许加班
                                    <el-switch
                                        v-model="overtimeForm.json_rule.off_day.is_open"
                                        :active-value="1"
                                        :inactive-value="0"
                                    >
                                    </el-switch>
                                </div>
                            </el-form-item>
                            <template v-if="overtimeForm.json_rule.off_day.is_open == 1">
                                <el-form-item label="加班时长单位" prop="json_rule.off_day.time_unit">
                                    <el-radio-group v-model="overtimeForm.json_rule.off_day.time_unit">
                                        <el-radio label="day">天</el-radio>
                                        <el-radio label="ampm">半天</el-radio>
                                        <el-radio label="hour">小时</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    label="日时长结算"
                                    prop="json_rule.off_day.hour_to_day"
                                    v-if="overtimeForm.json_rule.off_day.time_unit == 'hour'"
                                >
                                    加班满
                                    <el-input-number
                                        :controls="false"
                                        :min="0"
                                        class="inputClass"
                                        placeholder="请输入"
                                        v-model="overtimeForm.json_rule.off_day.hour_to_day"
                                    >
                                    </el-input-number>
                                    小时，计为1 天
                                </el-form-item>
                                <el-form-item label="计算方式" prop="json_rule.off_day.calculation_method">
                                    <el-radio-group
                                        class="blockRadio"
                                        v-model="overtimeForm.json_rule.off_day.calculation_method"
                                    >
                                        <el-radio label="approval_time">按审批时长计算</el-radio><br />
                                        <!-- <el-radio :label="2">在审批时长内，按打卡时长计算</el-radio><br /> -->
                                        <!-- <el-radio :label="3">无需审批，按打卡时长计算</el-radio><br /> -->
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="补偿方式" prop="json_rule.off_day.compensation_method">
                                    <el-radio-group
                                        @change="handleChange(overtimeForm.json_rule.off_day.compensation_method, 2)"
                                        class="blockRadio"
                                        v-model="overtimeForm.json_rule.off_day.compensation_method"
                                    >
                                        <div class="return_type_radio">
                                            <el-radio label="pay">计为加班费，</el-radio>
                                            <div>
                                                <span>加班费以1:</span>
                                                <el-input-number
                                                    :controls="false"
                                                    :min="0"
                                                    class="inputClass"
                                                    placeholder="请输入"
                                                    v-model="overtimeForm.json_rule.off_day.compensation_ratio"
                                                >
                                                </el-input-number>
                                                <span>结算</span>
                                            </div>
                                        </div>
                                        <div class="return_type_radio">
                                            <el-radio label="comp_leave">计为调休，</el-radio>
                                            <div>
                                                <span>加班时长以1:</span>
                                                <el-input-number
                                                    :controls="false"
                                                    :min="0"
                                                    class="inputClass inputClass_80"
                                                    placeholder="请输入"
                                                    v-model="overtimeForm.json_rule.off_day.compensation_ratio"
                                                >
                                                </el-input-number>
                                                <span>结算为调休假</span>
                                            </div>
                                        </div>

                                        <!--                  <el-radio :label="3">员工自主选择</el-radio><br>-->
                                    </el-radio-group>
                                </el-form-item>
                            </template>
                        </el-tab-pane>

                        <el-tab-pane label="节假日" name="3">
                            <el-form-item label="" prop="json_rule.holiday_day.is_open">
                                <div class="association">
                                    允许加班
                                    <el-switch
                                        v-model="overtimeForm.json_rule.holiday_day.is_open"
                                        :active-value="1"
                                        :inactive-value="0"
                                    >
                                    </el-switch>
                                </div>
                            </el-form-item>

                            <template v-if="overtimeForm.json_rule.holiday_day.is_open == 1">
                                <el-form-item label="加班时长单位" prop="json_rule.holiday_day.time_unit">
                                    <el-radio-group v-model="overtimeForm.json_rule.holiday_day.time_unit">
                                        <el-radio label="day">天</el-radio>
                                        <el-radio label="ampm">半天</el-radio>
                                        <el-radio label="hour">小时</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    label="日时长结算"
                                    prop="json_rule.holiday_day.hour_to_day"
                                    v-if="overtimeForm.json_rule.holiday_day.time_unit == 'hour'"
                                >
                                    加班满
                                    <el-input-number
                                        :controls="false"
                                        :min="0"
                                        class="inputClass"
                                        placeholder="请输入"
                                        v-model="overtimeForm.json_rule.holiday_day.hour_to_day"
                                    >
                                    </el-input-number>
                                    小时，计为1 天
                                </el-form-item>
                                <el-form-item label="计算方式" prop="json_rule.holiday_day.calculation_method">
                                    <el-radio-group
                                        class="blockRadio"
                                        v-model="overtimeForm.json_rule.holiday_day.calculation_method"
                                    >
                                        <el-radio label="approval_time">按审批时长计算</el-radio><br />
                                        <!-- <el-radio :label="2">在审批时长内，按打卡时长计算</el-radio><br /> -->
                                        <!-- <el-radio :label="3">无需审批，按打卡时长计算</el-radio><br /> -->
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="补偿方式" prop="json_rule.holiday_day.compensation_method">
                                    <el-radio-group
                                        @change="
                                            handleChange(overtimeForm.json_rule.holiday_day.compensation_method, 3)
                                        "
                                        class="blockRadio"
                                        v-model="overtimeForm.json_rule.holiday_day.compensation_method"
                                    >
                                        <div class="return_type_radio">
                                            <el-radio label="pay">计为加班费，</el-radio>
                                            <div>
                                                <span>加班费以1:</span>
                                                <el-input-number
                                                    :controls="false"
                                                    :min="0"
                                                    class="inputClass"
                                                    placeholder="请输入"
                                                    v-model="overtimeForm.json_rule.holiday_day.compensation_ratio"
                                                >
                                                </el-input-number>
                                                <span>结算</span>
                                            </div>
                                        </div>
                                        <div class="return_type_radio">
                                            <el-radio label="comp_leave">计为调休，</el-radio>
                                            <div>
                                                <span>加班时长以1:</span>
                                                <el-input-number
                                                    :controls="false"
                                                    :min="0"
                                                    class="inputClass inputClass_80"
                                                    placeholder="请输入"
                                                    v-model="overtimeForm.json_rule.holiday_day.compensation_ratio"
                                                >
                                                </el-input-number>
                                                <span>结算为调休假</span>
                                            </div>
                                        </div>
                                        <!--                  <el-radio :label="3">员工自主选择</el-radio><br>-->
                                    </el-radio-group>
                                </el-form-item>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
            </div>
            <div class="custom_drawer_footer">
                <el-button size="small" @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
                <el-button size="small" type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled"
                    >保存</el-button
                >
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { UpdateOvertimeRule } from "@/api";
export default {
    name: "OvertimeRuleTpl",
    props: {
        overtimeTplDialogVisible: {
            type: Boolean,
            default: false,
        },
        overtimeDetails: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            activeName: "1",
            overtimeForm: {
                name: "",
                // related_statutory_holidays: 0,
                status: 1,
                json_rule: {
                    work_day: {},
                    off_day: {},
                    holiday_day: {},
                },
                // work_day: {
                //     is_open: 1, // 是否打开
                //     time_unit: "hour", // 时长单位 天day 半天ampm 小时hour
                //     hour_to_day: 8, // 多少小时算1天 时长单位为hour的时候生效
                //     calculation_method: "approval_time", //计算方式 固定时长
                //     compensation_method: "pay", //补偿方式 pay加班费 comp_leave 调休假
                //     compensation_ratio: 1, //补偿比 1:x
                // },
            },
            // work_day_return_type_value1: 0,
            // work_day_return_type_value2: 0,
            // off_day_return_type_value1: 0,
            // off_day_return_type_value2: 0,
            // holiday_day_return_type_value1: 0,
            // holiday_day_return_type_value2: 0,
            overtimeFormRules: {
                name: [{ required: true, message: "请输入加班规则名称" }],
            },
            btnDisabled: false,
        };
    },
    created() {
        if (this.overtimeDetails && this.overtimeDetails.id) {
            const data = JSON.parse(JSON.stringify(this.overtimeDetails));
            this.overtimeForm.name = data.name;
            // this.overtimeForm.related_statutory_holidays = data.related_statutory_holidays;

            this.overtimeForm.json_rule = {
                work_day: data.json_rule.work_day || {},
                off_day: data.json_rule.off_day || {},
                holiday_day: data.json_rule.holiday_day || {},
            };
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:overtimeTplDialogVisible", false);
        },
        handleClickTab() {},
        handleChange(value, type) {
            if (value == 3) {
                // if(type == 1){this.overtimeForm.json_rule.work_day.return_type_value = 0}
                // if(type == 2){this.overtimeForm.json_rule.off_day.return_type_value = 0}
                // if(type == 3){this.overtimeForm.json_rule.holiday_day.return_type_value = 0}
            }
        },
        handleDialogConfirm() {
            this.$refs.overtimeForm.validate((valid) => {
                if (valid) {
                    const data = JSON.parse(JSON.stringify(this.overtimeForm));
                    if (
                        data.json_rule.work_day.compensation_method == "pay" &&
                        !data.json_rule.work_day.compensation_ratio
                    ) {
                        this.$message.error("请选择工作日加班费兑换天数");
                        return false;
                    }
                    if (
                        data.json_rule.work_day.compensation_method == "comp_leave" &&
                        !data.json_rule.work_day.compensation_ratio
                    ) {
                        this.$message.error("请选择工作日调休假兑换天数");
                        return false;
                    }
                    if (
                        data.json_rule.off_day.compensation_method == "pay" &&
                        !data.json_rule.off_day.compensation_ratio
                    ) {
                        this.$message.error("请选择休息日加班费兑换天数");
                        return false;
                    }
                    if (
                        data.json_rule.off_day.compensation_method == "comp_leave" &&
                        !data.json_rule.off_day.compensation_ratio
                    ) {
                        this.$message.error("请选择休息日调休假兑换天数");
                        return false;
                    }
                    if (
                        data.json_rule.holiday_day.compensation_method == "pay" &&
                        !data.json_rule.holiday_day.compensation_ratio
                    ) {
                        this.$message.error("请选择节假日加班费兑换天数");
                        return false;
                    }
                    if (
                        data.json_rule.holiday_day.compensation_method == "comp_leave" &&
                        !data.json_rule.holiday_day.compensation_ratio
                    ) {
                        this.$message.error("请选择节假日调休假兑换天数");
                        return false;
                    }
                    this.btnDisabled = true;
                    this.loading = true;
                    UpdateOvertimeRule({ id: this.overtimeDetails.id, ...data })
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.loading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.handleDialogClose();
                                        this.$emit("callbackSuccess");
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.loading = false;
                                // this.$message.error(res.message);
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.loading = false;
                        });
                }
            });
        },
    },
};
</script>

<style lang="scss">
.custom_attendance_overtimr_drawer {
    .el-drawer__header {
        padding: 16px 24px;
        margin-bottom: 0;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
    }
}

.custom_overtime_drawer_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .drawer_form_content {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        .el-form {
            .el-form-item__label {
                color: rgba(51, 51, 51, 1);
            }
            .el-radio {
                font-weight: 400;
                &.is-checked {
                    .el-radio__label {
                        color: #666666;
                    }
                }
            }
            .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
                border-color: #E4E7ED !important;
            }
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100%;
            }
            .customBox {
                &:before {
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    content: " ";
                    background: rgba(232, 232, 232, 1);
                    left: 0;
                    top: -8px;
                }
                .customBoxForm {
                    background: rgba(247, 248, 250, 1);
                    padding: 8px;
                    box-sizing: border-box;
                    position: relative;
                }
            }
            ul li {
                margin-bottom: 16px;
                &:last-child {
                    margin-bottom: 0;
                }
                > p {
                    color: rgba(51, 51, 51, 1);
                    font-size: 14px;
                    line-height: 22px;
                    margin-bottom: 4px;
                }
            }
            .airdrop_cycle_day {
                .el-input {
                    width: 100px;
                }

                .el-radio {
                    margin-bottom: 10px !important;
                }
            }
            .illustrateText {
                border-radius: 4px;
                background: rgba(237, 240, 244, 1);
                padding: 8px;
                color: rgba(102, 102, 102, 1);
                font-size: 12px;
                line-height: 18px;
                box-sizing: border-box;
                margin-top: 10px;
            }
            .validityClass .el-date-picker__header .el-date-picker__header-label:nth-of-type(1) {
                display: none;
            }
            .association {
                height: 38px;
                border-radius: 4px;
                background: rgba(237, 240, 244, 1);
                padding: 10px 8px;
                box-sizing: border-box;
                color: rgba(102, 102, 102, 1);
                line-height: 22px;
                font-size: 14px;
                position: relative;
                display: flex;
                align-items: center;
                gap: 8px;
            }
            .association i {
                color: rgba(255, 77, 79, 1);
                margin-right: 2px;
            }
            .blockRadio {
                padding-top: 2px;
                width: 100%;
                .el-radio {
                    margin-bottom: 12px !important;
                    color: #666666;
                    font-weight: 400;
                }
            }
            .inputClass {
                width: 60px;
                text-align: left;
                .el-input__inner {
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    padding: 0 3px;
                    font-size: 12px;
                }
            }
            .inputClass_80 {
                width: 80px;
            }
            .return_type_radio {
                .el-radio {
                    margin-right: 0;
                }
                & > div {
                    display: inline-block;
                    & > span {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: #666666;
                    }
                    .inputClass {
                        margin: 0 3px;
                    }
                }
            }
        }
    }

    .custom_drawer_footer {
        padding: 10px 24px;
        border-top: 1px solid rgba(232, 232, 232, 1);
        text-align: right;
    }
}
</style>
